<template>
    <p-modal
        name="AppleSalesModal"
        label="Apple Report"
        ref="AppleSalesModal"
        size="lg"
        @ok.prevent="handleModalOk"
    >
        <template v-slot:default>
            <p-form ref="appleSalesForm">
                <div class="container-fluid content-wrapper">
                    <b-row cols="1" cols-lg="2">
                        <b-col>
                            <p-card title="Suppliers" class="static-height">
                                <p-advanced-select name="supplier" dataType="suppliers" v-model="reportParameters.supplierId" rules="required"/>
                            </p-card>
                        </b-col>
                        <b-col>
                            <p-card title="Date Range" class="mt-3">
                                <p-date-range-widget
                                    :date-range-options="reportParameters"
                                />
                            </p-card>
                        </b-col>
                    </b-row>
                    <UserReportTemplate 
                        :user-report-template-options="userReportTemplateOptions"
                        v-model:selected-user-report-template-id="selectedUserReportTemplateId"
                        :selected-user-report-template="selectedUserReportTemplate"
                        v-model:template-name="templateName"
                        @selected-object="applyUserReportTemplate($event)" />
                </div>
            </p-form>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-row>
                <b-col>
                    <p-button
                        variant="outline-primary"
                        :is-busy="isBusy"
                        @click="cancel"
                        >Cancel</p-button
                    >
                    <p-button
                        variant="primary"
                        @click="ok"
                        :is-busy="isBusy"
                        class="ms-2"
                        >OK</p-button
                    >
                </b-col>
            </b-row>
        </template>
    </p-modal>
</template>
<script>
import axios from 'axios';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import ReportTemplates from '@/components/mixins/ReportTemplates.js';
import UserReportTemplate from '@/components/UserReportTemplate.vue';

export default {
    mixins: [ReportTemplates],
    components: { UserReportTemplate },
    data() {
        return {
            isBusy: false,
            // Identifies which report saved templates belong to; must match the report name in Reports.vue.
            reportName: 'Apple Report',
            reportParameters: {
                supplierId: null,
                startDate: null,
                endDate: null,
                dateOption: 0,
                locationId: null
            },
        };
    },
    methods: {
        async show() {
            this.$refs.AppleSalesModal.show();
            await this.loadUserReportTemplates();
        },
        // ReportTemplates hook: a saved supplier can be gone by the time the template is
        // loaded. The dropdown won't always catch that on its own — p-advanced-select only
        // re-checks its bound value when its option list contains disabled entries — so
        // verify against the loaded list here.
        async validateReportParameters(savedParameters) {
            if (savedParameters.supplierId == null) {
                return true;
            }

            const suppliers = await selectListOptionsDataContext.getStoreDropdownData('suppliers');

            return suppliers.some(supplier => supplier.value == savedParameters.supplierId);
        },
        handleModalOk: async function () {
            if (!(await this.$refs.appleSalesForm.validate())) {
                return;
            }

            this.isBusy = true;

            this.reportParameters.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();

            if (!(await this.saveUserReportTemplate())) {
                this.isBusy = false;
                return;
            }

            await axios
                .post('/sales/exportAppleSalesCsv', this.reportParameters, {
                    responseType: 'blob'
                })
                .then(result => {
                    downloadFileToBrowser(
                        result.data,
                        'Apple Report.csv',
                        'application/csv'
                    );
                    this.$appSuccess(`Apple Report generated successfully.`)
                    this.$refs.AppleSalesModal.hide();
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }
    },
};
</script>
